import { getYaNative } from '@yanolja-org/ya-native'
import { isNative } from '~/app/utils/typeguards'

/**
 *  @description  useBackFunc 에 등록한 콜백을 window 객체에 등록하여 전역적으로 사용하기 위한 함수
 *
 *  @param        callback  back key 를 눌렀을 때 실행할 콜백함수
 *  @param        name      callback function 의 이름. 이는 backKeyBridgeScope 에 등록한 콜백을 재사용하기 위함.
 *
 *  @return       cleanup function 을 리턴함.
 *                다만 cleanup 이 불필요한 상황에서는 리턴한 cleanup 함수를 실행시키지 않도록 한다.
 *                예) backKeyBridgeScope 에 등록된 콜백함수를 재사용해야하는 경우
 * */
export const backKeyBridgeFunction = (callback: () => void, name: string) => {
  const yaNative = getYaNative()

  if (!isNative(yaNative)) {
    return
  }

  // 전역 상태 관리를 위한 guard scope
  ;(window as any).backKeyBridgeScope = (window as any).backKeyBridgeScope ?? {}
  ;(window as any).backKeyBridgeScope[name] = callback

  yaNative.useBackFunc({ func: `window.backKeyBridgeScope.${name}()` })

  // cleanup
  return () => {
    yaNative.useBackFunc({ func: '' })
  }
}

export const getIsAppDeviceWebviewInServerSide = context => {
  const appDevice = getAppDevice(context)
  return getIsWebviewDevice(appDevice)
}

export const getAppDevice = context => {
  if (!context) {
    return ''
  }

  return (
    context.req.headers?.['app-device'] ||
    context.req.headers?.['app_device'] ||
    context.req.cookies?.['app-device'] ||
    ''
  ).toLowerCase()
}

/**
 *  header.app-device 가 가능한 값은 현재로썬 'android', 'ios', 'etc' 3 가지이다.
 * */
export const getIsWebviewDevice = (appDevice?: string) => {
  if (!appDevice) {
    return false
  }
  return appDevice === 'android' || appDevice === 'ios'
}
